<template>
  <div class="autocomplete2-container pa-0" style="margin-bottom:-10px">
    <v-row no-gutters>
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 9 : 9" class="px-2">
        <!-- onfocus="this.setAttribute('autocomplete', 'new-password');" instead of autocomplete="new-password" disables Chrome address suggestions -->
        <v-text-field
          v-if="this.country === 'DK'"
          ref="addressInput"
          :id="id"
          :label="label"
          clearable
          @click:clear="clear()"
          :disabled="disabled"
          :required="required"
          :rules="rules"
          :value="searchText || showChoosenAddress()"
          onfocus="this.setAttribute('autocomplete', 'new-password');"
          class="form-control"
          outlined
          dense
          color="primary"
          background-color="white"
          @input="searchAddresses"
          @keydown="
            e => {
              keyDownHandler(e);
            }
          "
        ></v-text-field>
        <div v-show="names && names.length > 0" class="autocomplete2-container">
          <ul
            class="dawa-autocomplete-suggestions"
            style="margin: -1.5em 0 0 0em; overflow;"
          >
            <li
              v-for="(name, i) in names"
              :key="i"
              :class="
                i === selectedName
                  ? 'dawa-autocomplete-suggestion dawa-selected'
                  : 'dawa-autocomplete-suggestion'
              "
              @mousedown="selectName(name)"
            >
              {{ name.tostring }}
            </li>
          </ul>
        </div>
        <v-text-field
          v-if="this.country !== 'DK'"
          ref="googleInput"
          :id="id"
          :label="label"
          placeholder=""
          clearable
          @click:clear="clear()"
          :disabled="disabled"
          :required="required"
          :rules="rules"
          v-model="googleText"
          class="form-control"
          onfocus="this.setAttribute('autocomplete', 'new-password');"
          outlined
          dense
          color="primary"
          background-color="white"
        ></v-text-field>
      </v-col>
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 3 : 3" class="pr-2">
        <v-select
          v-model="country"
          label="Land"
          :items="countries"
          no-data-text="Ingen lande tilgængelige"
          item-value="country_code"
          item-text="country_code"
          return-object
          :disabled="disabled"
          :required="required"
          :rules="countryRules"
          outlined
          dense
          color="primary"
          background-color="white"
          :menu-props="{
            contentClass: 'combobox-styled',
            auto: true,
            nudgeBottom: 40
          }"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Axios from "axios";
import proj4 from "proj4";
import { dictionary } from "@/helpers";
import { countries } from "@/helpers";
import { config } from "@/helpers";

proj4.defs(
  "EPSG:25832",
  "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs"
);

export default {
  props: ["addressType", "id", "label", "disabled", "required", "rules"],
  mounted() {
    this.clearNames();
    this.initializeGoogleAutocomplete();
  },
  data: () => ({
    names: [],
    selectedName: 0,
    searchText: "",
    searchTimer: null,
    searchSequence: 0,
    googleText: "",
    googleAutocomplete: null,
    countries: countries.elements,
    countryRules: [v => v.length > 0 || "Land mangler"]
  }),
  computed: {
    country: {
      get() {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          return this.$store.state.booking.data.pickup.address.country;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          return this.$store.state.booking.data.delivery.address.country;
        }
        return null;
      },
      set(value) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupCountry", value);
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryCountry", value);
        }
      }
    }
  },
  watch: {
    country() {
      if (this.addressType === dictionary.constants.address_types.pickup) {
        const address = this.$store.state.booking.data.pickup.address;
        address.address = "";
        address.zip = "";
        address.city = "";
        address.lat = "";
        address.lon = "";
        this.$store.commit("booking/updatePickupAddress", address);
      }
      if (this.addressType === dictionary.constants.address_types.delivery) {
        const address = this.$store.state.booking.data.delivery.address;
        address.address = "";
        address.zip = "";
        address.city = "";
        address.lat = "";
        address.lon = "";
        this.$store.commit("booking/updateDeliveryAddress", address);
      }

      this.googleText = "";
      this.$nextTick(() => this.initializeGoogleAutocomplete());
    }
  },
  methods: {
    initializeGoogleAutocomplete() {
      if (this.country === "DK" || this.googleAutocomplete) {
        return;
      }

      const input =
        this.$refs.googleInput &&
        this.$refs.googleInput.$el.querySelector("input");
      if (!input) {
        return;
      }

      if (
        !window.google ||
        !window.google.maps ||
        !window.google.maps.places
      ) {
        window.setTimeout(() => this.initializeGoogleAutocomplete(), 100);
        return;
      }

      this.googleAutocomplete = new window.google.maps.places.Autocomplete(
        input,
        {
          types: ["address"],
          componentRestrictions: {
            country: String(this.country).toLowerCase()
          }
        }
      );

      this.googleAutocomplete.addListener("place_changed", () => {
        const place = this.googleAutocomplete.getPlace();
        const selected = this.googlePlaceToAddress(place);
        this.googleText = selected.formatted_address || this.googleText;
        this.googleMapsAutocompleteSelect(selected);
      });
    },
    googlePlaceToAddress(place) {
      const components = place.address_components || [];
      const component = type => {
        const match = components.find(item => item.types.includes(type));
        return match ? match.long_name : "";
      };

      return {
        route: component("route"),
        street_number: component("street_number"),
        postal_code: component("postal_code"),
        locality: component("locality"),
        administrative_area_level_1: component("administrative_area_level_1"),
        administrative_area_level_2: component("administrative_area_level_2"),
        formatted_address: place.formatted_address || "",
        name: place.name || "",
        latitude: place.geometry ? place.geometry.location.lat() : "",
        longitude: place.geometry ? place.geometry.location.lng() : "",
        service: dictionary.constants.autocomplete_services.GoogleMaps
      };
    },
    searchAddresses(value) {
      this.searchText = value || "";
      this.clearNames();
      clearTimeout(this.searchTimer);

      if (!this.searchText || this.searchText.length < 1) {
        return;
      }

      const sequence = ++this.searchSequence;
      this.searchTimer = setTimeout(async () => {
        if (!config.adressevaelgerToken) {
          console.error("Missing VUE_APP_ADRESSEVAELGER_TOKEN");
          return;
        }

        try {
          const response = await Axios.get(
            `${config.adressevaelgerUrl}/adresser/soeg`,
            {
              params: {
                tekst: this.searchText,
                maksimum: 20,
                token: config.adressevaelgerToken
              }
            }
          );

          if (sequence !== this.searchSequence) {
            return;
          }

          this.names = (response.data.fund || []).map(address => ({
            tostring: address.titel,
            id: address.id,
            address,
            isKdsAddress: true,
            isKdsAccessAddress: address.type === "husnummer",
            isKdsStreetAddress:
              address.type === "vejnavn" ||
              address.type === "navngivenvejpostnummer"
          }));
        } catch (error) {
          console.error(error);
        }
      }, 200);
    },
    showChoosenAddress() {
      const addressJson =
        this.addressType === dictionary.constants.address_types.delivery
          ? this.$store.state.booking.data.delivery.address
          : this.addressType === dictionary.constants.address_types.pickup
          ? this.$store.state.booking.data.pickup.address
          : null;
      return addressJson && addressJson.address && addressJson.zip
        ? addressJson.address + ", " + addressJson.zip + " " + addressJson.city
        : "";
    },
    googleMapsAutocompleteSelect(selected) {
      const self = this;
      selected["service"] =
        dictionary.constants.autocomplete_services.GoogleMaps;

      const currentAddress =
        this.addressType === dictionary.constants.address_types.pickup
          ? this.$store.state.booking.data.pickup.address
          : this.$store.state.booking.data.delivery.address;
      const addressString =
        (selected.route || "") +
        (selected.street_number ? " " + selected.street_number : "");
      const addressObj = {
        address: addressString || selected.formatted_address || selected.name,
        zip: selected.postal_code || "",
        city:
          selected.locality ||
          selected.administrative_area_level_2 ||
          selected.administrative_area_level_1 ||
          "",
        country: currentAddress.country,
        lat: selected.latitude ? selected.latitude + "" : "",
        lon: selected.longitude ? selected.longitude + "" : ""
      };

      if (this.addressType === dictionary.constants.address_types.pickup) {
        this.$store.commit("booking/updatePickupAddress", addressObj);
      } else if (
        this.addressType === dictionary.constants.address_types.delivery
      ) {
        this.$store.commit("booking/updateDeliveryAddress", addressObj);
      }

      self.$emit("selected", selected);
      self.$nextTick(() => self.resetValidation());
    },
    resetValidation() {
      if (this.country === "DK" && this.$refs.addressInput) {
        this.$refs.addressInput.resetValidation();
        return;
      }

      if (
        this.$refs.googleAutocomplete &&
        typeof this.$refs.googleAutocomplete.resetValidation === "function"
      ) {
        this.$refs.googleAutocomplete.resetValidation();
        return;
      }

      if (
        this.$refs.googleAutocomplete &&
        this.$refs.googleAutocomplete.$refs &&
        this.$refs.googleAutocomplete.$refs.textField
      ) {
        this.$refs.googleAutocomplete.$refs.textField.resetValidation();
      }
    },
    async handleSelectedAddress(selected) {
      this.clearNames();
      if (
        (this.addressType === dictionary.constants.address_types.delivery &&
          (!this.$store.state.booking.data.delivery.address.name ||
            this.$store.state.booking.data.delivery.address.name.length ==
              0)) ||
        (this.addressType === dictionary.constants.address_types.pickup &&
          (!this.$store.state.booking.data.pickup.address.name ||
            this.$store.state.booking.data.pickup.address.name.length == 0))
      ) {
        const addressString =
          selected.data.vejnavn +
          " " +
          selected.data.husnr +
          (selected.data.etage ? ", " + selected.data.etage + "." : "") +
          (selected.data.dør ? " " + selected.data.dør : "");

        let addressObj = {
          address: addressString,
          zip: selected.data.postnr
        };

        let rows = (selected.forslagstekst || selected.titel).split("\n");
        rows = rows.map(row => row.replace(/ /g, "\u00a0"));

        const toAddressString = rows.join(", ");

        await this.$store
          .dispatch("booking/lookupNames", {
            address: addressObj
          })
          .then(
            response => {
              this.names.push({
                tostring: toAddressString,
                name: "",
                address: selected
              }); //empty default item
              response.forEach(name => {
                this.names.push({
                  tostring: name + ", " + toAddressString,
                  name: name,
                  address: selected
                });
              });

              // this.$refs.namesuggestions.focus();
            },
            error => {
              console.error(error);
            }
          );
      }

      this.searchText = "";
      this.$emit("selected", selected.data);
    },
    selectName(selected) {
      if (selected) {
        if (selected.isKdsAccessAddress) {
          this.searchText = selected.tostring;
          this.handleKdsAccessAddressSelected(selected);
          return;
        }

        if (selected.isKdsStreetAddress) {
          this.searchText = selected.tostring;
          this.handleKdsStreetAddressSelected(selected.address);
          return;
        }

        if (selected.isKdsAddress) {
          this.searchText = selected.tostring;
          this.handleKdsAddressSelected(selected.address || selected);
          return;
        }

        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupName", selected.name);
        } else if (
          this.addressType === dictionary.constants.address_types.delivery
        ) {
          this.$store.commit("booking/updateDeliveryName", selected.name);
        }
      }
      this.clearNames();
    },
    async handleKdsStreetAddressSelected(selected) {
      if (!selected || !selected.vejnavn) {
        console.error("KDS street result is missing a street name", selected);
        this.clearNames();
        return;
      }

      try {
        const params = {
          vejnavn: selected.vejnavn,
          maksimum: 20,
          token: config.adressevaelgerToken
        };
        if (selected.postnr) {
          params.postnummer = selected.postnr;
        }

        const response = await Axios.get(
          `${config.adressevaelgerUrl}/adresser/soeg`,
          { params }
        );

        this.names = (response.data.fund || []).map(address => ({
          tostring: address.titel,
          id: address.id,
          address,
          isKdsAddress: true,
          isKdsAccessAddress: address.type === "husnummer",
          isKdsStreetAddress:
            address.type === "vejnavn" ||
            address.type === "navngivenvejpostnummer"
        }));
        this.selectedName = 0;
      } catch (error) {
        console.error(error);
        this.clearNames();
      }
    },
    async handleKdsAccessAddressSelected(selected) {
      if (!selected || !selected.id) {
        console.error("KDS access address result is missing an id", selected);
        this.clearNames();
        return;
      }

      try {
        const response = await Axios.get(
          `${config.adressevaelgerUrl}/husnumre/${selected.id}/adresser`,
          {
            params: { token: config.adressevaelgerToken }
          }
        );

        this.names = (response.data.adresser || []).map(address => ({
          tostring: address.adressebetegnelse,
          id: address.id_lokalid,
          address: {
            id: address.id_lokalid,
            titel: address.adressebetegnelse
          },
          isKdsAddress: true
        }));
        this.selectedName = 0;
      } catch (error) {
        console.error(error);
        this.clearNames();
      }
    },
    async handleKdsAddressSelected(selected) {
      if (!selected || !selected.id) {
        console.error("KDS address result is missing an id", selected);
        this.clearNames();
        return;
      }

      try {
        const response = await Axios.get(
          `${config.adressevaelgerUrl}/adresser/${selected.id}`,
          {
            params: { token: config.adressevaelgerToken }
          }
        );
        const address = response.data.adresse;
        const coordinates = address.husnummer.adgangspunkt.koordinater;
        const wgs84 = proj4("EPSG:25832", "EPSG:4326", [
          coordinates.x,
          coordinates.y
        ]);
        const kdsAddress = address.husnummer;

        await this.handleSelectedAddress({
          data: {
            vejnavn: kdsAddress.vejnavn,
            husnr: kdsAddress.husnummertekst,
            etage: address.etagebetegnelse,
            dør: address.doerbetegnelse,
            postnr: kdsAddress.postnummer.postnr,
            postnrnavn: kdsAddress.postnummer.navn,
            x: wgs84[0],
            y: wgs84[1],
            forslagstekst: selected.titel,
            id: address.id_lokalid,
            service: dictionary.constants.autocomplete_services.DAWA
          },
          titel: selected.titel
        });
      } catch (error) {
        console.error(error);
      }
    },
    keyDownHandler(e) {
      if (e && this.names && this.names.length > 0) {
        const key = window.event ? e.keyCode : e.which;
        // down (40)
        if (key === 40) {
          this.selectedName = (this.selectedName + 1) % this.names.length;
          e.preventDefault();
        }
        //up (38)
        else if (key === 38) {
          this.selectedName =
            (this.selectedName - 1 + this.names.length) % this.names.length;
          e.preventDefault();
        }
        // enter
        else if (key === 13 || key === 9) {
          this.selectName(this.names[this.selectedName]);
          e.preventDefault();
        }
        // Other keys must remain available for text input.
      }
    },
    clear() {
      this.searchText = "";
      this.searchSequence++;
      this.clearNames();
      this.$emit("cleared");
    },
    clearNames() {
      this.names = [];
      this.selectedName = 0;
    }
  }
};
</script>

<style lang="scss">
@import url("../../assets/styles/colors.css");

.autocomplete2-container {
  /* relative position for at de absolut positionerede forslag får korrekt placering.*/
  position: relative;
  width: 100%;
  max-width: 40em;
}
.autocomplete2-container input {
  /* Både input og forslag får samme bredde som omkringliggende DIV */
  width: 100%;
  box-sizing: border-box;
}
.dawa-autocomplete-suggestions {
  //margin: 2em 0 0 0;
  margin: 1.3em 0 0 -0.7em;
  padding: 0 !important;
  text-align: left;
  // border-radius: 0.3125em;
  background: white;
  box-shadow: 0 0.0625em 0.15625em rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 0;
  right: 0;
  z-index: 9999;
  overflow-y: auto;
  box-sizing: border-box;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
  margin: 0;
  list-style: none;
  cursor: pointer;
  padding: 0.4em 0.6em;
  color: #333;
  border: 0.0625em solid #ddd;
  border-bottom-width: 0;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:last-child {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  border-bottom-width: 0.0625em;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion.dawa-selected,
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:hover {
  // background: #f0f0f0;
  background: var(--GLS-blue-10);
}
</style>
